export default function AirtimeLoader() {
  return (
    <div className="flex items-center justify-center py-24">
      <div className="h-14 w-14 animate-spin rounded-full border-4 border-emerald-500 border-t-transparent" />
    </div>
  );
}